import React, { useEffect, useState, useCallback } from 'react';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import api from '~/services/api';
import history from '~/services/history';
// Importando componentes
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function Temperatura() {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDados = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/temperaturas');

      setDados(response.data);
    } catch (error) {
      setLoading(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getDados();
  }, [getDados]);

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'time.name',
      label: 'Time',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  async function handlerStatus(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/temperaturas/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Temperatura excluido com sucesso');
            getDados();
          }
        });
      } else {
        const response = await api.delete(`/temperaturas/${number}`);

        if (response.data) {
          toast.success('Temperatura excluido com sucesso');
          getDados();
        }
      }
    } catch (error) {
      toast.error('Error ao ativar/desativar o time');
      getDados();
    } finally {
      setLoading(false);
    }
  }

  async function handlerEditar(number) {
    history.push(`/temperatura-edit/${number}`);
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Listagem de temperaturas</h4>
      <Card>
        <Menus>
          <NewButton to="/temperatura-create">
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={dados}
          columns={columns}
          ds={handlerStatus}
          ed={handlerEditar}
          messages="Você deseja excluir temperatura(s) ?"
          st
        />
      </Card>
    </Container>
  );
}
